import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Tooltip from '../../../components/ui/Tooltip';
import { cn } from '../../../utils/cn';

export const PRIORITIZE_NO_PHONE_TOOLTIP =
  "This candidate has no phone number. Add a phone number to enable prioritization for AI calls.";

const PrioritizeButton = ({
  isPrioritized = false,
  hasPhone = false,
  onClick,
  size = 'sm',
  fullWidth = false,
  className,
  showTooltip = true,
}) => {
  const { t } = useTranslation();

  const button = (
    <Button
      variant={isPrioritized ? 'default' : 'outline'}
      size={size}
      fullWidth={fullWidth}
      iconName="Phone"
      onClick={onClick}
      disabled={!hasPhone}
      className={className}
    >
      {isPrioritized ? t('candidates.priority') : t('candidates.prioritize')}
    </Button>
  );

  if (!hasPhone && showTooltip) {
    return (
      <Tooltip
        content={t('candidates.noPhoneTooltip')}
        align="start"
        size="md"
        className={cn(fullWidth && 'flex-1 w-full')}
      >
        <span
          className={cn(
            'inline-flex cursor-not-allowed',
            fullWidth && 'w-full flex-1'
          )}
        >
          {button}
        </span>
      </Tooltip>
    );
  }

  return button;
};

export default PrioritizeButton;
